import { render } from "./CleaningStatusChanger.vue?vue&type=template&id=5cb37d98"
import script from "./CleaningStatusChanger.vue?vue&type=script&lang=js"
export * from "./CleaningStatusChanger.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__